module.exports = __webpack_public_path__ + "media/images/front/icon_03_tag_gl-1431045ecbae669762642d67eea11b6e.png";